// extracted by mini-css-extract-plugin
export default {"container":"salesButtons_container__-iJDu","left":"salesButtons_left__MkF4B","text":"salesButtons_text__glHlR"};